import classNames from "classnames";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import { CheckActiveIcon, TimerIcon } from "../../AscIcons";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscModuleCard.module.scss";
dayjs.extend(duration);
dayjs.extend(relativeTime);

export interface AscModuleCardProps {
  title: string;
  lengthInMinutes?: number;
  completed?: boolean;
  className?: string;
  loading?: boolean;
}

export default function AscModuleCard({
  title,
  lengthInMinutes = 0,
  completed = false,
  className,
  loading,
}: AscModuleCardProps) {
  return (
    <AscGenericCard
      className={classNames(
        styles.ground,
        {
          [styles.completed]: completed,
          [styles.loading]: loading,
        },
        className
      )}
      loading={loading}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      title={title}
      imageClassName={styles.cardImage}
      customImage={
        <div className={styles.iconContainer}>
          <CheckActiveIcon
            className={styles.checkIcon}
            data-testid={"asc-skill-card-check-mark-icon"}
          />
        </div>
      }
    >
      <div className={styles.lengthContainer}>
        <TimerIcon className={styles.moduleIcon} />
        <span className={styles.length}>
          {dayjs.duration(lengthInMinutes, "minutes").humanize()}
        </span>
      </div>
    </AscGenericCard>
  );
}
